import { RssCrawlResultConstants } from "../constants/RssCrawlResultConstants";

/**
 * region for hepers*/

const initialState = {
  pending: false,
  ListResult: {},
};

export default function RssCrawlResultReducers(state = initialState, action) {
  switch (action.type) {
    case RssCrawlResultConstants.FETCH_RSS_CRAWL_RESULT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case RssCrawlResultConstants.FETCH_RSS_CRAWL_RESULT_ERROR:
      return {
        ...state,
        error: action.error,
        pending: false,
      };
    case RssCrawlResultConstants.FETCH_RSS_CRAWL_RESULT_GET_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        ListResult: action.payload,
      };
    default:
      return state;
  }
}
